"use client";

import { useIntl } from "react-intl";
import { match } from "ts-pattern";
import { Anchor, Button, cn, getLocaleAsset } from "../..";

type ErrorContentProps =
	| { variant?: "checkout" | "cart"; resetCart: () => Promise<void> }
	| { variant?: "default"; resetCart?: never };

export interface ErrorPageProps {
	error: Error & { digest?: string };
	reset: () => void;
}

export function ErrorContent({
	variant = "default",
	error,
	reset,
	resetCart,
}: ErrorContentProps & ErrorPageProps) {
	const intl = useIntl();

	return (
		<div
			className={cn("container grid grid-cols-4 py-10", {
				"rounded bg-white": variant === "cart",
			})}
		>
			<div className="prose col-span-4 sm:col-span-3">
				<div className="prose col-span-4 sm:col-span-3">
					<h1 className="font-extrabold text-9xl text-primary-medium">500</h1>
					<h2>
						{match(variant)
							.with("checkout", () =>
								intl.formatMessage({
									defaultMessage: "Er is een fout opgetreden bij het afrekenen",
								}),
							)
							.with("cart", () =>
								intl.formatMessage({
									defaultMessage: "Er is een fout opgetreden in de winkelwagen",
								}),
							)
							.otherwise(() =>
								intl.formatMessage({
									defaultMessage: "Er is een fout opgetreden",
								}),
							)}
					</h2>

					{!!error.digest && (
						<p>
							<i>{error.digest}</i>
						</p>
					)}

					<ol>
						<li>
							<Button variant="link" onClick={reset}>
								{intl.formatMessage({ defaultMessage: "Probeer opnieuw" })}
							</Button>
						</li>
						{(variant === "checkout" || variant === "cart") && (
							<li>
								<Button variant="link" onClick={resetCart}>
									{intl.formatMessage({
										defaultMessage: "Winkelwagen legen en opnieuw beginnen",
									})}
								</Button>
							</li>
						)}
						<li>
							<Button variant="link" onClick={history.back}>
								{intl.formatMessage({
									defaultMessage: "Ga terug naar de vorige pagina",
								})}
							</Button>
						</li>
						<li>
							<Anchor href="/">
								{intl.formatMessage({ defaultMessage: "Naar de homepagina" })}
							</Anchor>
						</li>
						<li>
							<Anchor href="/contacts">
								{intl.formatMessage({ defaultMessage: "Neem contact met ons op" })}
							</Anchor>
						</li>
					</ol>
				</div>
			</div>
			<div className="col-span-2 col-start-2 mt-10 sm:col-span-1 sm:col-start-4 sm:mt-0">
				<img
					src={getLocaleAsset("Karakters/hans_search.png")}
					width={801}
					height={651}
					alt={intl.formatMessage({
						defaultMessage: "Hans zoekt naar een oplossing",
					})}
				/>
			</div>
		</div>
	);
}
